<template>
    <v-flex>
        <v-row class="center">
            <v-col cols="11" md="8">
                <v-card class="graph-card py-6">
                    <h3>Map Traffic For {{ currentMonth }}</h3>
                    <v-row class="end me-6">
                        <v-btn-toggle background-color="secondary-icon" v-model="mapLabelControl" mandatory borderless>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="0">
                                        <v-icon style="height: 40px; width: 40px;" class="secondary-icon"
                                            >fas fa-calendar-alt</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Date Labels</span>
                            </v-tooltip>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="1">
                                        <inline-svg class="logo" :src="dataLabelIcon"></inline-svg>
                                    </v-btn>
                                </template>
                                <span>Traffic Labels</span>
                            </v-tooltip>
                        </v-btn-toggle>
                    </v-row>
                    <v-flex v-if="currentMapActiveTraffic">
                        <v-sparkline
                            auto-draw
                            :show-labels="true"
                            label-size="5"
                            line-width="2"
                            padding="15"
                            stroke-linecap="round"
                            :gradient="gradients"
                            :labels="mapDayLabels"
                            :value="currentMapActiveTraffic"
                        >
                        </v-sparkline>
                        <h4 v-if="mapLabelControl !== 0">Visits</h4>
                        <h4 v-else>Date Range</h4>
                    </v-flex>
                    <div v-else class="empty-graph center">
                        <v-col cols="4">
                            <v-row class="center">No Monthly Trend Data</v-row>
                            <v-row class="center">Check Back Tomorrow</v-row>
                        </v-col>
                    </div>
                    <v-divider></v-divider>
                    <v-row class="center py-5">
                        <v-col class="center">
                            <site-button
                                :colNum="9"
                                :marginNumber="3"
                                text="COMING SOON"
                                colorClasses="secondary-icon"
                                iconColor="primary-icon"
                                iconString="fas fa-tools"
                            ></site-button>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
        <v-row justify="space-around">
            <v-col cols="11" md="6">
                <v-card class="graph-card py-6">
                    <h3>Card Advertisement Traffic For {{ currentMonth }}</h3>
                    <v-row class="end me-6">
                        <v-btn-toggle background-color="secondary-icon" v-model="cardLabelControl" mandatory borderless>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="0">
                                        <v-icon style="height: 40px; width: 40px;" class="secondary-icon"
                                            >fas fa-calendar-alt</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Date Labels</span>
                            </v-tooltip>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="1">
                                        <inline-svg class="logo" :src="dataLabelIcon"></inline-svg>
                                    </v-btn>
                                </template>
                                <span>Traffic Labels</span>
                            </v-tooltip>
                        </v-btn-toggle>
                    </v-row>
                    <v-flex v-if="currentCardActiveTraffic">
                        <v-sparkline
                            auto-draw
                            :show-labels="true"
                            label-size="5"
                            line-width="2"
                            padding="15"
                            stroke-linecap="round"
                            :gradient="gradients"
                            :labels="cardLabels"
                            :value="currentCardActiveTraffic"
                        >
                        </v-sparkline>
                        <h4 v-if="cardLabelControl !== 0">Impressions</h4>
                        <h4 v-else>Date Range</h4>
                    </v-flex>
                    <div v-else class="empty-graph center">
                        <v-col cols="4">
                            <v-row class="center">No Monthly Trend Data</v-row>
                            <v-row class="center">Check Back Tomorrow</v-row>
                        </v-col>
                    </div>
                    <v-divider></v-divider>
                    <v-row class="center py-5">
                        <v-col class="center">
                            <site-button
                                :colNum="9"
                                :marginNumber="3"
                                text="Dating Card Ads"
                                iconType="SVG"
                                colorClasses="secondary-icon"
                                iconColor="primary-icon"
                                :iconString="cardAdImg"
                                @click-event="cardAds"
                            ></site-button>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="11" md="6">
                <v-card class="graph-card py-6">
                    <h3>Slider Advertisement Traffic For {{ currentMonth }}</h3>
                    <v-row class="end me-6">
                        <v-btn-toggle background-color="secondary-icon" v-model="sliderLabelControl" mandatory borderless>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="0">
                                        <v-icon style="height: 40px; width: 40px;" class="secondary-icon"
                                            >fas fa-calendar-alt</v-icon
                                        >
                                    </v-btn>
                                </template>
                                <span>Date Labels</span>
                            </v-tooltip>
                            <v-tooltip top class="secondary-tooltip">
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn v-bind="attrs" v-on="on" :value="1">
                                        <inline-svg class="logo" :src="dataLabelIcon"></inline-svg>
                                    </v-btn>
                                </template>
                                <span>Traffic Labels</span>
                            </v-tooltip>
                        </v-btn-toggle>
                    </v-row>
                    <v-flex v-if="currentSliderActiveTraffic">
                        <v-sparkline
                            auto-draw
                            :show-labels="true"
                            label-size="5"
                            line-width="2"
                            padding="15"
                            stroke-linecap="round"
                            :gradient="gradients"
                            :labels="sliderDayLabels"
                            :value="currentSliderActiveTraffic"
                        >
                        </v-sparkline>
                        <h4 v-if="sliderLabelControl !== 0">Impressions</h4>
                        <h4 v-else>Date Range</h4>
                    </v-flex>
                    <div v-else class="empty-graph center">
                        <v-col cols="4">
                            <v-row class="center">No Monthly Trend Data</v-row>
                            <v-row class="center">Check Back Tomorrow</v-row>
                        </v-col>
                    </div>
                    <v-divider></v-divider>
                    <v-row class="center py-5">
                        <v-col class="center">
                            <site-button
                                :colNum="9"
                                :marginNumber="3"
                                text="Slider Ads"
                                iconType="SVG"
                                colorClasses="secondary-icon"
                                iconColor="primary-icon"
                                :iconString="sliderAdImg"
                                @click-event="sliderAds"
                            ></site-button>
                        </v-col>
                    </v-row>
                </v-card>
            </v-col>
        </v-row>
    </v-flex>
</template>

<style>
.logo {
    height: 40px;
    width: 40px;
}

.logo ::v-deep.svg {
    cursor: pointer;
}
</style>

<script>
import SiteButton from '../../../components/common/SiteButton.vue'
import SvgInline from 'vue-inline-svg'
import utils from '../../../utilities/utils'
import TrafficType from '../../../assets/Enums/TrafficType'

export default {
    name: 'advertising-dashboard',
    components: {
        'site-button': SiteButton,
        'inline-svg': SvgInline,
    },
    data: () => ({
        gradients: ['#00006d', '#EE1D00'],
        selectedTerm: new Date().toISOString().substring(0,7),
        cardLabelControl: 0,
        sliderLabelControl: 0,
        mapLabelControl: 0,
        sliderData: {
            '2022-04': [
                { day: 1, traffic: 20 },
                { day: 3, traffic: 10 },
                { day: 13, traffic: 15 },
                { day: 14, traffic: 12 },
                { day: 15, traffic: 20 },
                { day: 18, traffic: 35 },
                { day: 20, traffic: 5 },
                { day: 22, traffic: 30 },
                { day: 23, traffic: 40 },
                { day: 25, traffic: 50 },
                { day: 28, traffic: 100 },
                { day: 30, traffic: 15 },
            ],
        },
        cardData: {
            '2022-04': [
                { day: 2, traffic: 20 },
                { day: 3, traffic: 25 },
                { day: 5, traffic: 10 },
                { day: 6, traffic: 30 },
                { day: 7, traffic: 30 },
                { day: 8, traffic: 30 },
                { day: 9, traffic: 30 },
                { day: 10, traffic: 30 },
                { day: 11, traffic: 30 },
                { day: 12, traffic: 15 },
                { day: 15, traffic: 20 },
                { day: 18, traffic: 35 },
                { day: 22, traffic: 30 },
                { day: 23, traffic: 40 },
                { day: 25, traffic: 50 },
                { day: 28, traffic: 100 },
            ],
        },
    }),
    methods: {
        sliderAds() {
            this.$router.push('slider-ads')
        },
        cardAds() {
            this.$router.push('business-branding')
        },
    },
    computed: {
        sliderAdImg() {
            return require('../../../assets/Slider-Ad.svg')
        },
        dataLabelIcon() {
            return require('../../../assets/Data-Label-Icon.svg')
        },
        cardAdImg() {
            return require('../../../assets/Card-Ads.svg')
        },
        addCardAdImg() {
            return require('../../../assets/Add-Card-Advertisement.svg')
        },
        addSliderAdImg() {
            return require('../../../assets/Add-Slider-Advertisement.svg')
        },
        businessTraffic(){
            return this.$store.getters.businessTraffic;
        },
        currentMapActiveTraffic(){
            console.log('selectedTerm: ' + this.selectedTerm);
            const traffic = this.$store.getters.businessTraffic.views.filter(item => {
                return item.term === this.selectedTerm && item.trafficType === TrafficType.Map
            });

            if (!traffic || traffic.length === 0) {
                return null
            } else if (traffic[0].day !== 1) {
                return [0, ...traffic.map(s => s.traffic)]
            } else {
                return traffic.map(s => s.traffic)
            }
        },
        currentSliderActiveTraffic() {
            console.log('selectedTerm: ' + this.selectedTerm);
            const traffic = this.$store.getters.businessTraffic.views.filter(item => {
                return item.term === this.selectedTerm && item.trafficType === TrafficType.SliderAd
            });

            if (!traffic || traffic.length === 0) {
                return null
            } else if (traffic[0].day !== 1) {
                return [0, ...traffic.map(s => s.traffic)]
            } else {
                return traffic.map(s => s.traffic)
            }
        },
        currentCardActiveTraffic() {
            const traffic = this.$store.getters.businessTraffic.views.filter(item => {
                return item.term === this.selectedTerm && item.trafficType === TrafficType.CardAd
            });

            if (!traffic || traffic.length === 0) {
                return null
            } else if (traffic[0].day !== 1) {
                return [0, ...traffic.map(s => s.traffic)]
            } else {
                return traffic.map(s => s.traffic);
            }
        },
        currentMonth() {
            return new Date().toLocaleString('default', { month: 'long' })
        },
        cardLabels() {
            const currentDate = new Date()
            const trafficKey = currentDate.toISOString().substring(0, 7)
            const data = this.cardData[trafficKey]

            if (this.cardLabelControl === 0) {
                if (data && data.length > 0) {
                    return utils.getDaysWithData(trafficKey, data)
                } else {
                    return null
                }
            } else {
                if (data && data.length > 0) {
                    return utils.getDataEntries(data)
                } else {
                    return null
                }
            }
        },
        sliderDayLabels() {
            const currentDate = new Date()
            const trafficKey = currentDate.toISOString().substring(0, 7)
            const data = this.$store.getters.businessTraffic.views.filter(item => {
                return item.term === this.selectedTerm;
            });

            if (this.sliderLabelControl === 0) {
                if (data && data.length > 0) {
                    return utils.getDaysWithData(trafficKey, data)
                } else {
                    return null
                }
            } else {
                if (data && data.length > 0) {
                    return utils.getDataEntries(data)
                } else {
                    return null
                }
            }
        },
        mapDayLabels(){
            const currentDate = new Date()
            const trafficKey = currentDate.toISOString().substring(0, 7)
            const data = this.$store.getters.businessTraffic.views.filter(item => {
                return item.term === this.selectedTerm;
            });

            if (this.mapLabelControl === 0) {
                if (data && data.length > 0) {
                    return utils.getDaysWithData(trafficKey, data)
                } else {
                    return null
                }
            } else {
                if (data && data.length > 0) {
                    return utils.getDataEntries(data)
                } else {
                    return null
                }
            }
        }
    },
}
</script>
